import React, { FunctionComponent } from 'react';
import * as honeybadger from '../../../../services/honeybadger';
import { Story } from '../../../../services/models/story';
import StoryCardLink from '../../../story-card-link/StoryCardLink';

interface StoryCardProps {
  story: Story;
  onStoryClick?: (storyId: number, storyUri: string) => void;
}

export const StoryCard: FunctionComponent<StoryCardProps> = ({ story, onStoryClick }) => {
  const storyCardClassName =
    'grid max-w-[600px] grid-cols-[1fr_16px_auto] grid-rows-[repeat(4,minmax(0px,auto))]';

  const getStoryDate = () => {
    try {
      return new Intl.DateTimeFormat('en', {
        month: 'short',
        day: 'numeric',
      }).format(new Date(story.publicationDate));
    } catch (e: any) {
      honeybadger.notify(e, 'StoryCard');
      return '';
    }
  };

  return (
    <article className={storyCardClassName}>
      {story.imageUrl && (
        <figure className="col-start-3 row-span-3 row-start-1 m-0 h-[100px] w-[100px]">
          <img
            className="block h-full w-full rounded-sm bg-gray-100 object-cover"
            src={story.imageUrl}
            alt={story.title}
            loading="lazy"
          />
        </figure>
      )}
      <div className="col-start-1 flex flex-wrap text-[0.75rem] font-bold uppercase text-gray-400">
        {story.source}
      </div>
      <div className="col-start-1 m-0 flex text-[1.25rem] font-bold leading-[1.25]">
        <StoryCardLink
          isClicked={story.isClicked}
          briefId={1}
          storyId={story.id}
          href={story.url}
          titleClick={onStoryClick}
        >
          {story.title}
        </StoryCardLink>
      </div>
      <div className="col-start-1 mt-[5px] flex truncate text-[0.875rem] text-gray-400">
        {story.author && (
          <>
            <span className="truncate">{story.author}</span>
            <span>&nbsp;–&nbsp;</span>
          </>
        )}
        <time dateTime={story.publicationDate.toLocaleString()}>{getStoryDate()}</time>
      </div>
      <div className="col-span-3 mt-4 flex break-words text-base leading-[1.3]">
        {story.excerpt}
      </div>
    </article>
  );
};
